function formatCurrency(price) {
  return Intl.NumberFormat().format (price);
}

export {
  formatCurrency
}